import { Loader } from '@googlemaps/js-api-loader';

export class ContactPage {
	constructor() {
		this.container = document.querySelector('.contactPage-gmap');
		this.mapContainer = document.querySelector('.acf-map');
		this.marker = this.mapContainer.querySelector('.marker');
		this.latLng = {
			lat: parseFloat(this.marker.getAttribute('data-lat')),
			lng: parseFloat(this.marker.getAttribute('data-lng')),
		};
		this.zoom = this.marker.getAttribute('data-zoom');
	}

	init() {
		console.log(this.latLng);
		const loader = new Loader({
			apiKey: 'AIzaSyCc4TQxO5Wym4fS0xBs9RJegH_0oEcqZ1Y',
			version: 'weekly',
		});

		loader
			.load()
			.then((google) => {
				this.initMap(google);
			})
			.catch((e) => {
				console.error('Error loading Google Maps API:', e);
			});
	}

	initMap(google) {
		let map;

		const mapArgs = {
			zoom: this.zoom || 16,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: this.latLng,
			disableDefaultUI: true,
			styles: [
				{
					stylers: [
						{
							saturation: -100,
						},
					],
				},
			],
		};

		map = new google.maps.Map(this.mapContainer, mapArgs);

		map.markers = [];
		this.initMarker(google, map);

		return map;
	}

	initMarker(google, map) {
		const icon = {
			url: '/wp-content/themes/redboxmediarefonte2022/public/images/icon_animated.gif', // url
			scaledSize: new google.maps.Size(60, 77),
			anchor: new google.maps.Point(25, 40),
		};

		const marker = new google.maps.Marker({
			position: this.latLng,
			map: map,
			icon: icon,
		});

		map.markers.push(marker);
	}
}
